import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { bookingActions, hairdresserActions } from '../_actions';

// Old staff pages that ran on the legacy v1 backend. Each now lands on the
// screen that replaced it, so bookmarks and stray links keep working.

const diaryPath = (salonId) => '/diary/' + (salonId || localStorage.getItem('salonId') || '');

// /checkout/:bookingId and /new-booking-edit/:bookingId → the booking in the
// diary, where checkout and edit both live now.
export const BookingInDiaryRedirect = ({ match }) => (
  <Redirect to={diaryPath() + '/booking/' + match.params.bookingId} />
);

// /newbooking/:salonId(/:hairdresserId) → the diary with the New Booking
// sidebar open, seeded the same way the client panel seeds it.
class NewBookingRedirectInner extends Component {
  state = { done: false };

  componentDidMount() {
    const { dispatch, match, user } = this.props;
    const me = localStorage.getItem('userId');
    const wanted = match.params.hairdresserId || me;
    const finish = () => this.setState({ done: true });
    dispatch(hairdresserActions.hairdresserStaffRota({ searchKey: '', hairdresserId: me, page: 1, listType: 1 }))
      .then((res) => {
        const rota = (res && res.data && res.data.data && res.data.data.rota) || [];
        const staffList = rota.filter((s) => s && s.name).map((s) => ({ ...s, id: s._id || s.id }));
        if (staffList.length) {
          const pick = staffList.find((s) => s.id === wanted) || staffList.find((s) => s.id === me) || staffList[0];
          dispatch(bookingActions.openMinimisedBooking({
            staffId: pick.id,
            bookingDate: new Date(),
            staffList,
            currencySymbol: (user && user.userInfo && user.userInfo.hairdresser && user.userInfo.hairdresser.currencySymbol) || '£',
          }));
        }
        finish();
      })
      .catch(finish);
  }

  render() {
    if (!this.state.done) return null;
    return <Redirect to={diaryPath(this.props.match.params.salonId)} />;
  }
}

export const NewBookingRedirect = connect((state) => ({ user: state.user }))(NewBookingRedirectInner);
